import React from 'react';
import { Flex } from '@chakra-ui/react';
import { WebIcon } from '../../utils/icons/web';
import { AndroidIcon } from '../../utils/icons/android';
import { AppleIcon } from '../../utils/icons/apple';
import { LinuxIcon } from '../../utils/icons/linux';
import { WindowsIcon } from '../../utils/icons/windows';

export enum PlatformType {
	HTML = 'HTML',
	PC = 'PC',
	OSX = 'OSX',
	LINUX = 'LINUX',
	ANDROID = 'ANDROID',
	IOS = 'IOS',
}

export const PlatformIcon: { [p: string]: React.ReactNode } = {
	[PlatformType.HTML]: <WebIcon />,
	[PlatformType.ANDROID]: <AndroidIcon />,
	[PlatformType.IOS]: <AppleIcon />,
	[PlatformType.LINUX]: <LinuxIcon />,
	[PlatformType.PC]: <WindowsIcon />,
	[PlatformType.OSX]: <AppleIcon />,
};

export const Platform = ({ data, isGray, ...props }: { data: string[]; isGray: boolean } | any) => {
	return (
		<Flex
			gridGap="5px"
			alignItems="center"
			{...props}
		>
			<Flex
				gridGap="8px"
				alignItems="center"
			>
				{data.map((platform: PlatformType) => (
					<Flex key={platform}>{PlatformIcon[platform.toUpperCase()]}</Flex>
				))}
			</Flex>
		</Flex>
	);
};
